import type { ReactNode } from 'react';
import { useTracking } from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';

export interface RawDataModalProps {
  title?: ReactNode;
  isVisible: boolean;
  onClose: () => void;
  children: ReactNode;
}

const RawDataModal = ({
  title,
  onClose,
  children,
  isVisible,
}: RawDataModalProps) => {
  const { Track } = useTracking({
    type: 'track',
    chart: title,
    subject: 'RawDataModal',
  });
  return isVisible ? (
    <Track>
      <Modal
        title={title}
        onSecondaryClick={onClose}
        onPrimaryClick={onClose}
        primaryLabel="Close"
      >
        <div>{children}</div>
      </Modal>
    </Track>
  ) : null;
};

export default RawDataModal;
